import React, { SVGProps } from 'react';

const OtherworldOriginalsIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 20 21"
			fill="none"
			width="100%"
			height="100%"
			{...props}
		>
			<path
				d="M18.6806 5.40741C17.8009 3.87963 16.5972 2.69907 15.0926 1.81944C13.5648 0.939815 11.875 0.5 10 0.5C8.125 0.5 6.43518 0.939815 4.90741 1.81944C3.37963 2.69907 2.19907 3.90278 1.31944 5.40741C0.439815 6.93518 0 8.625 0 10.5C0 12.375 0.439815 14.0648 1.31944 15.5926C2.19907 17.1204 3.40278 18.3009 4.90741 19.1806C6.43518 20.0602 8.125 20.5 10 20.5C11.875 20.5 13.5648 20.0602 15.0926 19.1806C16.6204 18.3009 17.8009 17.0972 18.6806 15.5926C19.5602 14.088 20 12.375 20 10.5C20 8.625 19.5602 6.93518 18.6806 5.40741ZM15.8102 14.0648C15.2315 15.1065 14.4444 15.8935 13.4259 16.4722C12.4074 17.0278 11.2731 17.3287 10 17.3287C8.72685 17.3287 7.59259 17.0509 6.57407 16.4722C5.55556 15.8935 4.76852 15.1065 4.18981 14.0648C3.61111 13.0231 3.33333 11.8426 3.33333 10.5C3.33333 9.15741 3.61111 7.97685 4.18981 6.93518C4.76852 5.89352 5.55556 5.10648 6.57407 4.52778C7.59259 3.94907 8.72685 3.6713 10 3.6713C11.2731 3.6713 12.4074 3.94907 13.4259 4.52778C14.4444 5.08333 15.2315 5.89352 15.8102 6.93518C16.3889 7.97685 16.6667 9.15741 16.6667 10.5C16.6667 11.8426 16.3889 13.0231 15.8102 14.0648Z"
				fill="currentColor"
			/>
			<path
				d="M9.88106 15.1568C8.98744 13.383 7.76404 11.8584 6.34288 10.7474L6.16016 10.6043L6.34288 10.4612C7.76466 9.35017 8.98807 7.82553 9.88106 6.0517L10.045 5.72656L10.2083 6.0517C11.102 7.8249 12.3254 9.34954 13.7465 10.4612L13.9293 10.6043L13.7465 10.7474C12.3254 11.859 11.102 13.3836 10.2083 15.1568C10.1796 15.214 10.045 15.3483 10.045 15.3483C10.045 15.3483 9.90985 15.214 9.88106 15.1568Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export default OtherworldOriginalsIcon;
